// Import CSS
import 'aos/src/sass/aos.scss';
import '@mathieustan/vue-datepicker/dist/vue-datepicker.min.css';

// import style (>= Swiper 6.x)
import 'swiper/css/swiper.css'

//Import vue components
import Vuex from 'vuex'
import AOS from 'aos';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import VueVideoSection from 'vue-video-section'
import SkyReveal from 'sky-reveal';
import moment from 'moment'
import VueDatePicker from '@mathieustan/vue-datepicker';
import VueYouTube from 'vue-youtube';
import VTooltip from 'v-tooltip'

// App main
const main = async () => {
	// Async load the vue module
	const { default: Vue } = await import('vue');

	//Vue Use
	Vue.use(VueAwesomeSwiper);
	Vue.use(SkyReveal);
	Vue.use(Vuex);
	Vue.use(VueDatePicker);
	Vue.use(VueYouTube);
	Vue.use(VTooltip)

	//Vuex config and mutations
	const store = new Vuex.Store({
		state: {
			isSiteMenuOpen: false,
			isDonationFormOpen: false,
		},
		mutations: {
			setSiteMenuState(state, value){
				state.isSiteMenuOpen = value
			},
			setDonationFormState(state, value){
				state.isDonationFormOpen = value
			},
		},
	})
	
	// Moment Date formatter (for socialfeeds)
	Vue.filter('formatDate', function (value) {
		if (value) {
			return moment(String(value)).format('DD.MM.YY')
		}
	})

	// Create our vue instance
	const vm = new Vue({
		el: '#root',
		delimiters: ['${', '}'],
		store,
		components: {
			// Site
			'BlogGrid': () => import(/* webpackChunkName: "Bloggrid" */ './vue/BlogGrid.vue'),

			// Blocks
			'Accordion': () => import(/* webpackChunkName: "Accordion" */ './vue/Accordion.vue'),
			'FullWidthSlider': () => import(/* webpackChunkName: "FullWidthSlider" */ './vue/FullWidthSlider.vue'),
			'EmbeddedVideo': () => import(/* webpackChunkName: "EmbeddedVideo" */ './vue/EmbeddedVideo.vue'),
			'FultonElement': () => import(/* webpackChunkName: "FultonElement" */ './vue/FultonElement.vue'),

			// Menues
			'SiteMenu': () => import(/* webpackChunkName: "SiteMenu" */ './vue/SiteMenu.vue'),
			'SiteMenuOverlay': () => import(/* webpackChunkName: "SiteMenuOverlay" */ './vue/SiteMenuOverlay.vue'),

			// Socials
			'FacebookFeed': () => import(/* webpackChunkName: "FacebookFeed" */ './vue/FacebookFeed.vue'),
			'InstagramFeed': () => import(/* webpackChunkName: "InstagramFeed" */ './vue/InstagramFeed.vue'),
			'CombinedFeed': () => import(/* webpackChunkName: "CombinedFeed" */ './vue/CombinedFeed.vue'),

			// Forms
			'ApplyForm': () => import(/* webpackChunkName: "ApplyForm" */ './vue/ApplyForm.vue'),
			'VisitationForm': () => import(/* webpackChunkName: "VisitationForm" */ './vue/VisitationForm.vue'),
			'CallForm': () => import(/* webpackChunkName: "CallForm" */ './vue/CallForm.vue'),
			'DonationForm': () => import(/* webpackChunkName: "DonationForm" */ './vue/DonationForm.vue'),
			'DonationFormOverlay': () => import(/* webpackChunkName: "DonationFormOverlay" */ './vue/DonationFormOverlay.vue'),
			
			// Vue
			VueVideoSection,
		},
		data() {
			return {
			}
		},
		methods: {
			openSiteMenu(){
				store.commit('setSiteMenuState', true)
			},
			openDonationForm(){
				store.commit('setDonationFormState', true)
			},
		},

		computed: {
			isSiteMenuOpen() {
				return store.state.isSiteMenuOpen
			},
			isDonationFormOpen() {
				return store.state.isDonationFormOpen
			},
		},
		
		created() {
			 AOS.init({
				easing: 'ease-in-out',
                offset: 50,
                duration: 500,
				delay: 0,
				once: true,
				startEvent: 'load',
				anchorPlacement: 'top-bottom',
			})
		},

		destroyed() {
		},

		beforeMount: function () { },

		mounted() { },
	})

	return vm
}

// Execute async function
main().then((vm) => { })

// Accept HMR as per: https://webpack.js.org/api/hot-module-replacement#accept
if (module.hot) {
	module.hot.accept()
}

